import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${({ $marginBottom }) => $marginBottom ?? '20px'};
  opacity: ${({ $opacity }) => $opacity ?? 0.7};
`;

const EmptyStateIcon = ({ width = 80, height = 80, marginBottom, opacity, className }) => (
  <IconWrapper $marginBottom={marginBottom} $opacity={opacity} className={className}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20 25 H 80 L 70 65 H 30 L 20 25 Z" fill="#e9ecef" />
      <path
        d="M30 70 C 30 75.5 34.5 80 40 80 H 60 C 65.5 80 70 75.5 70 70"
        stroke="#ced4da"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <circle cx="35" cy="88" r="4" fill="#adb5bd" />
      <circle cx="65" cy="88" r="4" fill="#adb5bd" />
      <line
        x1="35"
        y1="35"
        x2="65"
        y2="55"
        stroke="#adb5bd"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        x1="65"
        y1="35"
        x2="35"
        y2="55"
        stroke="#adb5bd"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  </IconWrapper>
);

EmptyStateIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  marginBottom: PropTypes.string,
  opacity: PropTypes.number,
  className: PropTypes.string,
};

export default EmptyStateIcon;
